<section class="material-table">
  <p-treeTable [value]="traceMaterialData" (onNodeExpand)="onNodeExpand($event)" (onNodeCollapse)="onNodeCollapse($event)">
    <ng-template pTemplate="header">
      <tr>
        <th class="material-table__toggle-cell">
          <i
            class="material-table__expand-collapse-icon"
            [ngClass]="tableExpanded ? 'icon-collapse-all' : 'icon-expand-all'"
            (click)="expandCollapseTable()"
          ></i>
        </th>
        <th class="material-table__tiny-cell"></th>
        <th class="material-table__text-cell">{{ 'MOUNTING.ARTICLE' | translate }}</th>
        <th colspan="2" class="material-table__text-cell">{{ 'MOUNTING.NAME' | translate }}</th>
        <th class="material-table__text-cell"></th>
        <th class="material-table__text-cell"></th>
        <th class="material-table__text-cell">{{ 'MOUNTING.QUANTITY' | translate }}</th>
        <th class="material-table__text-cell">{{ 'MOUNTING.ASSIGNED' | translate }}</th>
        <th *ngIf="buttonTemplate"></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
      <tr
        [ngClass]="{
        'first-level-row': rowData.displayMode === MaterialTableDataRowDisplayMode.BillOfMaterial,
        'second-level-row': rowData.displayMode === MaterialTableDataRowDisplayMode.Container,
      }"
      >
        <td class="material-table__toggle-cell">
          <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
        </td>
        <td class="material-table__tiny-cell"></td>
        <ng-container *ngIf="rowData.displayMode === MaterialTableDataRowDisplayMode.BillOfMaterial; else batchInfo">
          <td class="material-table__text-cell">
            <div class="material-table__article-icon-layout">
              <lib-article-classification
                [classification]="rowData.article.classification"
                [size]="ArticleClassificationSize.Small"
              ></lib-article-classification>
              <div class="material-table__article-layout">{{ rowData.article.externalArticleId }}</div>
            </div>
          </td>
          <td [colSpan]="2" class="material-table__text-cell">{{ rowData.article.articleName | emptyTextPlaceholder }}</td>
          <td class="material-table__text-cell"></td>
          <td class="material-table__number-cell"></td>
          <td class="material-table__text-cell">
            <ng-container *ngIf="rowData.containerCount">
              <i class="assigned-icon icon-container"></i>
              {{ rowData.containerCount }}
            </ng-container>
          </td>
          <td class="material-table__text-cell">
            <i *ngIf="rowData.containerCount" class="assigned-icon icon-checked-solid"></i>
          </td>
          <td class="material-table__last-cell" *ngIf="buttonTemplate">
            <ng-container *ngTemplateOutlet="buttonTemplate; context: { $implicit: rowData }"></ng-container>
          </td>
        </ng-container>
        <ng-template #batchInfo>
          <td class="material-table__text-cell material-table__less-important-text">
            <div>{{ rowData.batchInternalTitle | translate }}</div>
            <div>{{ rowData.internalBatchId | emptyTextPlaceholder }}</div>
          </td>
          <td class="material-table__text-cell material-table__less-important-text">
            <div>{{ rowData.batchExternalTitle | translate }}</div>
            <div>{{ rowData.externalBatchId | emptyTextPlaceholder }}</div>
          </td>
          <ng-container *ngIf="isAlternativeAvailable(rowNode.parent.data); then alternative; else emptyAlternative"></ng-container>
          <td colspan="3" class="material-table__text-cell material-table__less-important-text">
            <div>{{ rowData.infoTitle | translate }}</div>
            <div>{{ rowData.virtualContainerInfo | emptyTextPlaceholder }}</div>
          </td>
          <td class="material-table__last-cell" *ngIf="buttonTemplate">
            <ng-container *ngTemplateOutlet="buttonTemplate; context: { $implicit: rowData }"></ng-container>
          </td>
        </ng-template>

        <ng-template #emptyAlternative>
          <td [colSpan]="2" class="material-table__number-cell"></td>
        </ng-template>
        <ng-template #alternative>
          <td [colSpan]="2" class="material-table__text-cell">
            {{ rowNode.parent.data.alternativeArticles[0].articleName | emptyTextPlaceholder }}
            <br />
            {{ rowNode.parent.data.alternativeArticles[0].externalArticleId | emptyTextPlaceholder }}
            <br />
            {{ rowNode.parent.data.alternativeArticles[0].externalConfigurationId | emptyTextPlaceholder }}
          </td>
        </ng-template>
      </tr>
    </ng-template>
  </p-treeTable>
  <lib-table-no-data-message [loading]="loading" [data]="traceMaterialData"></lib-table-no-data-message>
  <lib-table-loading-indicator [loading]="loading" [data]="traceMaterialData"></lib-table-loading-indicator>
</section>
